// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3IXBT","col":"CardReaderDesc_col__2nmIJ","label":"CardReaderDesc_label__3l808"};